import axios from "axios";
import config from "config";

const instance = axios.create({
  baseURL: config.API_URL,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
    "X-Requested-With": "com.qwizard.android",
  },
});

export default instance;
